<template>
  <div id="models">
    <Counter :limitTime="timeLimit" @timeUp="nextRound" v-if="!(showModal)" :roundNumber="round" />
    <SearchModal v-if="showModal" :searchfor="searchedModel" />
    <span v-for="(model, index) in activeModels" v-bind:key="index">
      <Model :id="index" :background="model.background" :searched="model.searched" :rotationSpeed="model.rotationSpeed" :transformation="null" v-if="model.showing"  @excludeModel="onExcludeModel" />
    </span>
  </div>
</template>

<script>
const Model = () => import('./Model.vue')
// import Model from './Model.vue'
const SearchModal = () => import('./SearchModal.vue')
// import SearchModal from './SearchModal.vue'
const Counter = () => import('./Counter.vue')
// import Counter from './Counter.vue'
export default {
  name: 'Models',
  components: {
    Model,
    SearchModal,
    Counter
  },
  props: {
    rounds: Number
  },
  created: function(){

    this.getSearchModels();
    this.setRandomSearchedModel();
    // this.setRotationSpeed();
    this.round = 1;
  },
  data: function() {
    return{
      activeModels: [],
      excluded: [],
      round: 0,
      showModal: false,
      searchedModel: null,
      found: [],
      timeLimit: window.options.settings.time_limit
    }
  },
  methods: {
    getSearchModels(){
      window.config.models.forEach((model, key) => {
        this.activeModels.push({
          rotationSpeed: (Math.floor(Math.random()+12 * key) )+1200,
          searched: false,
          showing: true,
          background: 'url('+model.img_path+')'
        });
      });
    },
    showSearchModal(id){
      this.searchedModel = this.activeModels[id];
      this.searchedModel.id = id;
      this.showModal = true;
      setTimeout(() => { this.showModal = false; }, 1800);
    },
    setRandomSearchedModel(){
      var random = (Math.floor(Math.random() * (this.activeModels.length) ));
      if(!(this.excluded.includes(random))){
        this.activeModels[random].searched=true;
        this.showSearchModal(random);
      }
      else{
        this.setRandomSearchedModel();
      }
    },
    onExcludeModel(value, found){
      this.excluded.push(value);
      if(found==true){this.found.push(this.searchedModel)}
      if( (this.round++) < this.rounds){
        this.reinitialize();
      }
      else{
        this.quit();
      }
    },
    reinitialize(){

      this.$forceUpdate();
      this.setRandomSearchedModel();

      // this.setRotationSpeed();
    },
    quit(){

      this.$emit('gamestate', 'over');
      this.$emit('found', this.found);
    },
    nextRound(){
      this.activeModels[this.searchedModel.id].showing=false;
      this.onExcludeModel(this.searchedModel.id,false);
    }

  }
}
</script>
